import { CheckApiKey, CheckPolicy, jwtVerify, Resource } from '../../framework/permission-util'
import { RT } from '../permissions'
import Executive from '../../framework/rmi-util'
import { register } from '../../framework/rmi-server-util'
import { assignContract, ContractTemplateForContractorAssignment, deleteContractSequence, getContractor, getContractorsForList, getContractorWithFields, getContractSequencesByTags, getContractTemplateDetails, getContractTemplatesForContractorAssignment, getContractTemplateWithFields, importContractors, upsertContractTemplate, updateContractor, signContracts, ContractorFilterItem, getContractorSalesChannels, generateViewContractsToken, getContractsAndContractorsByToken, getContractors, bulkUpdateContractors, sendKafkaMessage, subscribeToKafkaTopic, sendReminder, getContractorsWithoutContract, getContractTemplatesForClient, deleteCascadeContractors, importMysSpsAsContractors, createContractorForMysSp, terminateContracts, signContractsWithToken, bulkUpdateContractorsWithToken, getContractsAndContractorsByProviderId, getContractsAndContractorsByContractorId, getContractorServiceProvider, bulkSetTerminationDateToContract, bulkSetNeedsContract, contractTemplateFactory, contractTemplateHasContracts, getContractsThatNeedAttention, exportContractors, updateContractorPeakId, downloadContract, logContractorPageVisit, getContractorRecentChanges, logContractTemplatePageVisit, getContractTemplateRecentChanges, clearContractorCache, clearContractorCacheForClient, updateContractorLogo, deleteContractorLogo, getContractTemplatesOfSequenceType, getDefaultTourOperatorTemplate, getContractorsForServiceProvider, getContractTemplatesForList, ContractTemplateForList, getContractorContractTypes, contractorIsTourOperatorBySpId, contractorIsTourOperatorBySpIds, getContractorForEmail, exportLogoUrlAsFile, checkServiceProvidersExist } from './ContractTechnical'
import { Contract, Contractor, ContractSequence, ContractTemplate } from './contract.entities'
import { GenerateViewContractsTokenResponse, GetContractsAndContractorsResponse, TerminateContractsResult } from './util/types'
import { auditService } from '../audit/AuditTechnical'
import { EntityType } from '../audit/audit.types'
import { ContractSequenceType } from './contract.entities'
export default class ContractExecutive extends Executive {

	initServer() {
	}

	@CheckApiKey()
	async importContractors(clientId: string, contractorType: string): Promise<void> {
		return await importContractors(clientId, contractorType)
	}

	@CheckPolicy()
	async upsertContractTemplate(@Resource(RT.CLIENT) clientId: string, template: ContractTemplate, contractSequenceType: ContractSequenceType): Promise<ContractTemplate> {
		return await upsertContractTemplate(clientId, template, contractSequenceType)
	}
	
	@CheckApiKey()
	async upsertContractTemplateWithAi(clientId: string, template: ContractTemplate): Promise<ContractTemplate> {
		// append metadata field to outline that this was created with ai
		template.metadata = {
			...template.metadata,
			createdWithAi: true
		}
		return await upsertContractTemplate(clientId, template)
	}

	@CheckPolicy()
	async getContractTemplatesForContractorAssignment(@Resource(RT.CLIENT) clientId: string, canSeeObjectWithTags: string[]): Promise<ContractTemplateForContractorAssignment[]> {
		return await getContractTemplatesForContractorAssignment(clientId, canSeeObjectWithTags)
	}

	@CheckPolicy()
	async getContractSequencesByTags(@Resource(RT.CLIENT) clientId: string, canSeeObjectWithTags: string[]): Promise<ContractSequence[]> {
		return await getContractSequencesByTags(clientId, canSeeObjectWithTags)
	}

	@CheckPolicy()
	async getContractTemplatesForList(@Resource(RT.CLIENT) clientId: string, canSeeObjectWithTags: string[]): Promise<ContractTemplateForList[]> {
		return await getContractTemplatesForList(clientId, canSeeObjectWithTags)
	}

	@CheckPolicy()
	async getContractTemplateDetails(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTTEMPLATE) templateId: string): Promise<ContractTemplate> {
		return await getContractTemplateDetails(templateId)
	}

	@CheckPolicy()
	async getContractTemplatesOfSequenceType(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTSEQUENCE) contractSequenceType: ContractSequenceType): Promise<ContractTemplate[]> {
		return await getContractTemplatesOfSequenceType(clientId, contractSequenceType)
	}

	@CheckApiKey()
	async getContractTemplatesOfSequenceTypeExternal(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTSEQUENCE) contractSequenceType: ContractSequenceType): Promise<ContractTemplate[]> {
		return await getContractTemplatesOfSequenceType(clientId, contractSequenceType)
	}

	@CheckPolicy()
	async getContractTemplateWithFields(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTTEMPLATE) templateId: string, options: { fields: string[], populate: string[] }): Promise<ContractTemplate> {
		return await getContractTemplateWithFields(templateId, options)
	}

	@CheckPolicy()
	async assignContract(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTTEMPLATE) contractTemplateId: string, @Resource(RT.CONTRACTOR) contractorIds: string[]): Promise<{assignedCount: number, totalCount: number}> {
		return await assignContract(clientId, contractTemplateId, contractorIds)
	}

	@CheckApiKey()
	async assignContractExternal(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTTEMPLATE) contractTemplateId: string, @Resource(RT.CONTRACTOR) contractorIds: string[]): Promise<{assignedCount: number, totalCount: number}> {
		return await assignContract(clientId, contractTemplateId, contractorIds)
	}

	async signContractsWithToken(clientId: string, contractorId: string, contractIds: string[], signatureName: string, signaturePosition: string, token: string, signedLocale: string): Promise<void> {
		return await signContractsWithToken(clientId, contractorId, contractIds, signatureName, signaturePosition, token, signedLocale)
	}

	@CheckPolicy()
	async signContracts(clientId: string, @Resource(RT.CONTRACTOR) contractorId: string, @Resource(RT.CONTRACT) contractIds: string[], signatureName: string, signaturePosition: string, signedLocale: string): Promise<void> {
		return await signContracts(clientId, contractorId, contractIds, signatureName, signaturePosition, signedLocale)
	}

	@CheckPolicy()
	async getContractors(@Resource(RT.CLIENT) clientId: string): Promise<Contractor[]> {
		return await getContractors(clientId)
	}

	@CheckPolicy()
	async getContractorsForServiceProvider(@Resource(RT.PROVIDER) serviceProviderId: string): Promise<Contractor[]> {
		return await getContractorsForServiceProvider(serviceProviderId)
	}

	@CheckApiKey()
	async getContractorsForServiceProviderExternal(@Resource(RT.PROVIDER) serviceProviderId: string): Promise<Contractor[]> {
		return await getContractorsForServiceProvider(serviceProviderId)
	}

	@CheckPolicy()
	async updateContractor(@Resource(RT.CONTRACTOR) contractor: Contractor, fieldsToUpdate: string[]): Promise<void> {
		await updateContractor(contractor, fieldsToUpdate)
	}

	@CheckPolicy()
	async uploadContractorLogo(base64Data: string, filename: string, @Resource(RT.CONTRACTOR) contractorId: string, @Resource(RT.PROVIDER) serviceProviderId?: string, @Resource(RT.CLIENT) clientId?: string): Promise<string> {
		return await updateContractorLogo(base64Data, filename, contractorId, serviceProviderId)
	}

	@CheckPolicy()
	async deleteContractorLogo(@Resource(RT.CONTRACTOR) contractorId: string, @Resource(RT.PROVIDER) serviceProviderId?: string, @Resource(RT.CLIENT) clientId?: string): Promise<string> {
		await deleteContractorLogo(contractorId, serviceProviderId)
	}

	@CheckPolicy()
	async getContractor(@Resource(RT.CONTRACTOR) contractorId: string): Promise<Contractor> {
		return await getContractor(contractorId)
	}

	@CheckPolicy()
	async getContractorWithFields(@Resource(RT.CONTRACTOR) contractorId: string, fields: string[]): Promise<Contractor> {
		return await getContractorWithFields(contractorId, fields)
	}

	@CheckPolicy()
	async getContractorsForList(@Resource(RT.CLIENT) clientId: string, filters: ContractorFilterItem[], canSeeObjectWithTags: string[]): Promise<Contractor[]> {
		return await getContractorsForList(clientId, filters, canSeeObjectWithTags)
	}

	@CheckPolicy()
	async getContractorSalesChannels(@Resource(RT.CLIENT) clientId: string): Promise<any[]> {
		return await getContractorSalesChannels(clientId)
	}

	@CheckPolicy()
	async getContractorServiceProvider(@Resource(RT.CLIENT) clientId: string, serviceProviderId: string): Promise<Contractor> {
		return await getContractorServiceProvider(clientId, serviceProviderId);
	}

	// This is called externally (from API1 - peak sync) - we check for a valid api key here since we do not have a user context
	@CheckApiKey()
	async updateContractorPeakId(clientId: string, serviceProviderId: string, peakId: string): Promise<boolean> {
		return await updateContractorPeakId(clientId, serviceProviderId, peakId)
	}

	@CheckApiKey()
	async deleteContractSequence(sequenceId: string): Promise<void> {
		return await deleteContractSequence(sequenceId)
	}

	async generateViewContractsToken(contractorId: string, isReadonly: boolean = false): Promise<GenerateViewContractsTokenResponse> {
		return await generateViewContractsToken(contractorId, isReadonly)
	}

	// verify api key instead of check policy
	// @CheckApiKey()
	// async generateViewContractsTokenExternalExample(email: string, isReadonly: boolean = false): Promise<GenerateViewContractsTokenResponse> {
	// 	return await generateViewContractsToken(email, isReadonly)
	// }

	async getContractsAndContractorsByToken(token: string): Promise<GetContractsAndContractorsResponse> {
		return await getContractsAndContractorsByToken(token)
	}
	
	@CheckPolicy()
	async getContractsAndContractorsByProviderId(@Resource(RT.PROVIDER) providerId: string): Promise<GetContractsAndContractorsResponse> {
		return await getContractsAndContractorsByProviderId(providerId)
	}

	@CheckPolicy()
	async getContractsAndContractorsByContractorId(@Resource(RT.CONTRACTOR) contractorId: string): Promise<{
		contractors: Contractor[],
		contractsByContractor: Record<string, Contract[]>,
		clientNames: Record<string, string>
	}> {
		return await getContractsAndContractorsByContractorId(contractorId);
	}

	async bulkUpdateContractorsWithToken(contractors: Contractor[], token: string): Promise<void> {
		return await bulkUpdateContractorsWithToken(contractors, token)
	}

	@CheckPolicy()
	async bulkUpdateContractors(@Resource(RT.CONTRACTOR) contractors: Contractor[]): Promise<void> {
		return await bulkUpdateContractors(contractors)
	}

	@CheckPolicy()
	async sendReminder(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTOR) contractorIds: string[], ignoreRecentlySent: boolean): Promise<{sentCount: number, totalCount: number}> {
		return await sendReminder(clientId, contractorIds, ignoreRecentlySent)
	}

	@CheckPolicy()
	async sendKafkaMessage(@Resource(RT.CLIENT) clientId: string, topic: string, data: any): Promise<void> {
		return await sendKafkaMessage(topic, data)
	}

	@CheckPolicy()
	async subscribeToKafkaTopic(@Resource(RT.CLIENT) clientId: string, topic: string): Promise<void> {
		return await subscribeToKafkaTopic(topic)
	}

	@CheckPolicy()
	async getContractorsWithoutContract(@Resource(RT.CLIENT) clientId: string): Promise<Number> {
		return await getContractorsWithoutContract(clientId)
	}

	@CheckPolicy()
	async getContractTemplatesForClient(@Resource(RT.CLIENT) clientId: string): Promise<ContractTemplate[]> {
		return await getContractTemplatesForClient(clientId)
	}

	@CheckPolicy()
	async deleteCascadeContractors(@Resource(RT.CLIENT) clientId: string): Promise<void> {
		return await deleteCascadeContractors(clientId)
	}

	@CheckPolicy()
	async deleteCascadeMysSpContractors(@Resource(RT.CLIENT) clientId: string): Promise<void> {
		return await deleteCascadeContractors(clientId, true)
	}

	@CheckPolicy()
	async importMysSpsAsContractors(@Resource(RT.CLIENT) clientId: string): Promise<{
		successCount: number,
		failureCount: number,
		totalProcessed: number
	}> {
		return await importMysSpsAsContractors(clientId)
	}

	// This is called externally (from API1) - we check for a valid api key here since we do not have a user context
	@CheckApiKey()
	async createContractorForMysSp(clientId: string, serviceProviderId: string): Promise<string> {
		return await createContractorForMysSp(serviceProviderId, clientId)
	}

	@CheckPolicy()
	async bulkSetTerminationDateToContract(endDate: Date, shouldReceiveEmail: boolean, @Resource(RT.CONTRACT) contractIds: string[]): Promise<{ terminatedCount: number, totalCount: number }> {
		return await bulkSetTerminationDateToContract(endDate, shouldReceiveEmail, contractIds);
	}

	@CheckPolicy()
	async bulkSetNeedsContract(@Resource(RT.CONTRACTOR) contractorIds: string[]): Promise<{updatedCount: number, totalCount: number}> {
		return await bulkSetNeedsContract(contractorIds)
	}

	@CheckPolicy()
	async terminateContracts(): Promise<TerminateContractsResult> {
		return await terminateContracts()
	}

	@CheckPolicy()
	async contractTemplateHasContracts(@Resource(RT.CONTRACTTEMPLATE) templateId: string): Promise<boolean> {
		return await contractTemplateHasContracts(templateId)
	}

	@CheckPolicy()
	async getDefaultTourOperatorTemplate(@Resource(RT.CLIENT) clientId: string): Promise<ContractTemplate | null> {
		return await getDefaultTourOperatorTemplate(clientId)
	}

	@CheckPolicy()
	async getContractsThatNeedAttention(@Resource(RT.CONTRACTOR) contractorId: string): Promise<Contract[]> {
		return await getContractsThatNeedAttention(contractorId)
	}

	@CheckPolicy()
	async getContractorContractTypes(@Resource(RT.CONTRACTOR) contractorId: string): Promise<ContractSequenceType[]> {
		return await getContractorContractTypes(contractorId)
	}

	@CheckPolicy()
	async exportContractors(@Resource(RT.CLIENT) clientId: string, @Resource(RT.CONTRACTOR) contractorIds: string[]) {
		const buffer = await exportContractors(clientId, contractorIds)
		return buffer
	}

	async contractTemplateFactory(type: ContractSequenceType): Promise<ContractTemplate> {
		return await contractTemplateFactory(type)
	}

	async downloadContractByToken(contractId: string, token: string, locale: string): Promise<Buffer> {
		jwtVerify(token)
		return await downloadContract(contractId, locale)
	}

	@CheckPolicy()
	async downloadContract(@Resource(RT.CONTRACT) contractId: string, locale: string): Promise<Buffer> {
		return await downloadContract(contractId, locale)
	}

	@CheckPolicy()
	async logContractorPageVisit(@Resource(RT.CONTRACTOR) contractorId: string, route: string): Promise<void> {
		return await logContractorPageVisit(contractorId, route)
	}

	@CheckPolicy()
	async getContractorRecentChanges(@Resource(RT.CONTRACTOR) contractorId: string): Promise<{
		changes: any[]
		lastVisit?: Date
		hasUnseenChanges: boolean
	}> {
		return await getContractorRecentChanges(contractorId)
	}

	@CheckPolicy()
	async getContractorChangesSince(@Resource(RT.CONTRACTOR) contractorId: string, sinceDate: Date): Promise<{
		changes: any[]
	}> {
		try {
			const result = await auditService.getChangesForEntitySince(EntityType.CONTRACTOR, contractorId, sinceDate)
			
			return {
				changes: result.changes.map(change => ({
					id: change.id,
					createdAt: change.createdAt,
					userEmail: change.userEmail,
					userRole: change.userRole,
					action: change.action,
					changeSummary: change.changeSummary,
					changedFields: change.changedFields
				}))
			}
		} catch (error) {
			console.error('Error getting contractor changes since date:', error)
			return {
				changes: []
			}
		}
	}

	@CheckPolicy()
	async logContractTemplatePageVisit(@Resource(RT.CONTRACTTEMPLATE) templateId: string, route: string): Promise<void> {
		return await logContractTemplatePageVisit(templateId, route)
	}

	@CheckPolicy()
	async getContractTemplateRecentChanges(@Resource(RT.CONTRACTTEMPLATE) templateId: string): Promise<{
		changes: any[]
		lastVisit?: Date
		hasUnseenChanges: boolean
	}> {
		return await getContractTemplateRecentChanges(templateId)
	}

	@CheckPolicy()
	async getContractTemplateChangesSince(@Resource(RT.CONTRACTTEMPLATE) templateId: string, sinceDate: Date): Promise<{
		changes: any[]
	}> {
		try {
			const result = await auditService.getChangesForEntitySince(EntityType.CONTRACT_TEMPLATE, templateId, sinceDate)
			
			return {
				changes: result.changes.map(change => ({
					id: change.id,
					createdAt: change.createdAt,
					userEmail: change.userEmail,
					userRole: change.userRole,
					action: change.action,
					changeSummary: change.changeSummary,
					changedFields: change.changedFields
				}))
			}
		} catch (error) {
			console.error('Error getting contract template changes since date:', error)
			return {
				changes: []
			}
		}
	}
	
	@CheckPolicy()
	async contractorIsTourOperatorBySpId(@Resource(RT.CLIENT) clientId: string, @Resource(RT.PROVIDER) serviceProviderId: string): Promise<boolean> {
		return await contractorIsTourOperatorBySpId(serviceProviderId)
	}

	@CheckApiKey()
	async contractorIsTourOperatorBySpIds(@Resource(RT.PROVIDER) serviceProviderIds: string[]): Promise<Record<string, boolean>> {
		return await contractorIsTourOperatorBySpIds(serviceProviderIds)
	}

	// @CheckPolicy()
	async clearContractorCache(): Promise<void> {
		return await clearContractorCache()
	}

	// @CheckPolicy()
	async clearContractorCacheForClient(clientId: string): Promise<void> {
		return await clearContractorCacheForClient(clientId)
	}

	@CheckApiKey()
	async clearContractorCacheForClientExternal(clientId: string): Promise<void> {
		return await clearContractorCacheForClient(clientId)
	}

	@CheckApiKey()
	async getContractorForEmail(email: string): Promise<Contractor> {
		return await getContractorForEmail(email)
	}

	async exportContractorLogoToPeak(url: string): Promise<Buffer> {
		return await exportLogoUrlAsFile(url)
	}

	@CheckPolicy()
	async checkServiceProvidersExist(@Resource(RT.CLIENT) clientId: string, serviceProviderIds: string[]): Promise<Record<string, boolean>> {
		return await checkServiceProvidersExist(serviceProviderIds)
	}
}

register(ContractExecutive)
